class SocialProofCard extends HTMLElement {
  constructor() {
    super();
    const trigger = this.querySelector('.social-proof-card__video-trigger');
    this.template = this.querySelector('.social-proof-card__video-template');

    if (trigger) {
      trigger.addEventListener('click', (e) => this.#openModal(e));
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') this.#openModal(e);
      });
    }
  }

  #openModal(e) {
    e?.preventDefault();
    const modal = document.getElementById('SocialProofModal');
    const content = document.getElementById('SocialProofModalContent');
    const closeBtn = modal?.querySelector('.social-proof__modal-close');

    if (!modal || !content || !this.template) return;

    content.innerHTML = this.template.innerHTML;
    modal.showModal();
    document.body.style.overflow = 'hidden';

    content.querySelector('video')?.play().catch(console.warn);

    const closeModal = () => {
      modal.close();
      content.innerHTML = '';
      document.body.style.overflow = '';
      closeBtn.removeEventListener('click', closeModal);
    };

    closeBtn.addEventListener('click', closeModal, { once: true });
  }
}

if (!customElements.get('social-proof-card')) {
  customElements.define('social-proof-card', SocialProofCard);
}
